import { css } from "@emotion/react";

import { fontSize } from "~/client/styles/emotion/mixins/fontSize";
import tokens from "~/packages/design-tokens/dist/tokens";

export const containerCss = css({
  paddingBottom: "12px",
});

export const containerWithSeparatorCss = css({
  paddingBottom: "12px",
  borderBottom: `1px solid ${tokens.color.border.primary.value}`,
});

export const headerCss = css({
  padding: "16px 16px 8px",
});

export const titleCss = css({
  ...fontSize(12),
  fontWeight: "normal",
  color: tokens.color.text.tertiary.default.value,
});
